import { RecursivePartial, IOptions } from '@tsparticles/engine';

const config: RecursivePartial<IOptions> = {
  particles: {
    number: {
      value: 80,
      density: {
        enable: true,
        height: 20,
        width: 24,
      },
    },
    color: {
      value: '#ffffff',
    },
    shape: {
      type: 'circle',
      options: {
        stroke: {
          width: 0,
          color: '#ffaf4d',
        },
        polygon: {
          nb_sides: 5,
        },
      },
    },
    opacity: {
      value: 0.8,
      random: false,
      anim: {
        enable: true,
        speed: 0.1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 0.5,
      random: true,
      anim: {
        enable: true,
        speed: 1,
        size_min: 1,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 160,
      color: '#ffffff',
      opacity: 0.1,
      width: 0.5,
    },
    bounce: { horizontal: { value: 0 }, vertical: { value: 0 } },
    move: {
      enable: true,
      speed: 0.4,
      direction: 'none',
      random: false,
      straight: false,
      outModes: 'out',
    },
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: {
        enable: true,
        mode: 'grab',
      },
      onclick: {
        enable: false,
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 200,
        line_linked: {
          opacity: 0.15,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: true,
};

export default config;
